import RouteOfAdministrationService from '../../services/RouteOfAdministrationService';

export default {
    state: {
        collection: [],
    },
    getters: {
        getAllRouteOfAdministration: store => store.collection,
        getSingleRouteOfAdministration: store => (id) => {
            const items = store.collection.filter(wada => wada.id === id);

            return items.length > 0 ? items[0] : {};
        },
    },
    mutations: {
        loadRouteOfAdministration(state, payload) {
            state.collection = payload;
        },
    },
    actions: {
        async loadRouteOfAdministration(context, substanceId) {
            try {
                let payload = [];
                if (substanceId) {
                    payload = await RouteOfAdministrationService.getAllBySubstanceId(substanceId);
                } else {
                    payload = await RouteOfAdministrationService.getAll('');
                }
                context.commit('loadRouteOfAdministration', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
        async loadRouteOfAdministrationWithDeleteFlags(context) {
            try {
                const payload = await RouteOfAdministrationService.getAll('?withdeleteflags=true');
                context.commit('loadRouteOfAdministration', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
    },
    namespaced: true,
};
